import { getGlobalVariablesService } from './utils/getGlobalVariablesService';

export async function deleteGlobalVariable(variableId: string): Promise<void> {
  await getGlobalVariablesService().remove(variableId);
}
